import uuid from '@/util/uuid'

import filesConfig from '@/assets/files'

import fileTypes from '@/config/fileTypes'

import generatePronouncableString from '@/util/generatePronouncableString'

export default ({
  fileSlug,
  id,
  locked
}) => {
  if (!filesConfig[fileSlug]) {
    throw new Error('Unknown file asset "' + fileSlug + '"')
  }

  const type = filesConfig[fileSlug].type

  return {
    // Asset details
    fileSlug,
    name: filesConfig[fileSlug].name,
    size: filesConfig[fileSlug].size,
    type,

    // Type details
    ...fileTypes[type],

    // File details
    id: id || uuid(),
    encryptedName: generatePronouncableString(),
    locked: !!locked
  }
}
